import { DONATION_INITIAL, FORM_INITIAL } from "./createCommentStepsHelper";

/**
 * Deep links into the memorial page's create flows, e.g. from Mina sidor:
 *
 *   ?intent=gift      opens the "Ge minnesgåva" modal
 *   ?intent=greeting  opens the "Skriv ett minnesord" modal
 *
 * The param is removed from the URL once read, so a reload or a shared link
 * doesn't open the modal again.
 */
export const INTENT_PARAM = "intent";
export const INTENT_GIFT = "gift";
export const INTENT_GREETING = "greeting";

const INTENT_CONTEXTS = {
  [INTENT_GIFT]: DONATION_INITIAL,
  [INTENT_GREETING]: FORM_INITIAL,
};

export function getIntentFromUrl(search = window.location.search) {
  const intent = new URLSearchParams(search).get(INTENT_PARAM);

  return Object.hasOwn(INTENT_CONTEXTS, intent) ? intent : null;
}

export function getIntentModalContext(intent) {
  return INTENT_CONTEXTS[intent] ?? null;
}

export function removeIntentFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);

  if (!urlParams.has(INTENT_PARAM)) {
    return;
  }

  urlParams.delete(INTENT_PARAM);

  const remainingUrlParams = urlParams.toString();
  const url =
    window.location.pathname +
    (remainingUrlParams ? `?${remainingUrlParams}` : "") +
    window.location.hash;

  window.history.replaceState(window.history.state, document.title, url);
}
